// NEW
import React from "react";
import { Navigate, Outlet } from "react-router-dom";

import "../../assests/css/admin/AdminPanel.css";
import AdminSidebar from "../../components/Admin/adminSidebar";
import AdminNavbar from "../../components/Admin/AdminNavbar";

const AdminMasterLayout = () => {
  if (!localStorage.getItem("adminToken")) {
    return <Navigate to="/admin/login" replace />;
  }

  return (
    <div className="admin-layout">
      
      {/* Sidebar */}
      <aside className="admin-sidebar">
        <AdminSidebar />
      </aside>

      {/* Main area */}
      <main className="admin-main">
        
        {/* Navbar */}
        <header className="admin-navbar">
          <AdminNavbar />
        </header>

        {/* Content */}
        <section className="admin-content">
          <Outlet />
        </section>

      </main>
    </div>
  );
};

export default AdminMasterLayout;
